import { Lock } from 'lucide-react';

/** Eigentümer (Board „BuchungEigentuemer“): statt leerer „geschützt“-Reiter ein Satz, was sie sehen. */
export function OwnerProtectedNote() {
  return (
    <p className="border-hairline rounded-tile flex h-fit items-start gap-3 border bg-white p-5 text-sm">
      <Lock size={18} aria-hidden className="text-ink-soft mt-0.5 flex-none" />
      <span>
        <b className="block">Gast-Daten sind geschützt</b>
        <span className="text-ink-soft">
          Name, Kontakt, Onboarding, Rechnungen und Notizen sieht nur die Verwaltung. Sie sehen
          Zeitraum, Status und Preis.
        </span>
      </span>
    </p>
  );
}
